module.exports = __webpack_public_path__ + "img/tab-image3.a346a772.png";